export enum ImageScale {
	// 768x432
	BANNER = 'BANNER',
	// 300x100
	LONG = 'LONG',
	// 140x140
	LARGE = 'LARGE',
	// 280x280
	LARGE_2X = 'LARGE_2X',
	// 560x560
	LARGE_4X = 'LARGE_4X',
	// 100x100
	MEDIUM = 'MEDIUM',
	// 60x60
	SMALL = 'SMALL',
	// 32x32
	MINI = 'MINI',
	// 47x47
	HEADER_AVATAR = 'HEADER_AVATAR',
	// 759x427
	VENUE = 'VENUE',
}

export const enum DocumentType {
	IMAGE_AVATAR = 'IMAGE_AVATAR',
	IMAGE_LOGO = 'IMAGE_LOGO',
	DOCUMENT = 'DOCUMENT',
}

export interface ImageParams {
	// 'path'
	pt: DocumentType;
	// Image ID
	md: string;
	// Owner ID
	sd: string;
	// Default URL
	dr: string;
	// size
	sc: ImageScale;
}

export interface TimedRightImage {
	params: ImageParams;
	src: string;
}

export interface ExternalImage {
	src: string;
}

// eslint-disable-next-line
export const EMPTY_LARGE_LOGO = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCABkAGQDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3O1tbdrOBmgiJMakkoOeKm+x2v/PtD/3wKLP/AI8rf/rmv8qmoAh+x2v/AD7Q/wDfAo+x2v8Az7Q/98CpqKAIfsdr/wA+0P8A3wKPsdr/AM+0P/fAqaigCH7Ha/8APtD/AN8Cj7Ha/wDPtD/3wKmooAh+x2v/AD7Q/wDfAo+x2v8Az7Q/98CpqKAIfsdr/wA+0P8A3wKPsdr/AM+0P/fAqaigDndZjjivEWNFQeWDhRjuaKdrn/H6n/XMfzNFAG1Z/wDHlb/9c1/lU1Q2f/Hlb/8AXNf5VNQAUUUUAFFFFABRRRQAUUUUAFFFFAHP65/x+p/1zH8zRRrn/H6n/XMfzNFAG1Z/8eVv/wBc1/lU1Q2f/Hlb/wDXNf5VNQAUUUUAFFFFABRRRQAUUUUAFFFFAHP65/x+p/1zH8zRRrn/AB+p/wBcx/M0UAbVn/x5W/8A1zX+VTVDZ/8AHlb/APXNf5VNQAUUUUAFFFFABRRRQAUUUUAFFFFAHP65/wAfqf8AXMfzNFGuf8fqf9cx/M0UAbVn/wAeVv8A9c1/lU1Q2f8Ax5W//XNf5VNQAUUUUAFFFFABRRRQAUUUUAFFFFAHP65/x+p/1zH8zRRrn/H6n/XMfzNFAG1Z/wDHlb/9c1/lU1Q2f/Hlb/8AXNf5VNQAUUUUAFFFFABRRRQAUUUUAFFFFAHP65/x+p/1zH8zRRrn/H6n/XMfzNFADY9ZuIokjVIsIoUZB7fjTv7cuv8AnnD+R/xoooAP7cuv+ecP5H/Gj+3Lr/nnD+R/xoooAP7cuv8AnnD+R/xo/ty6/wCecP5H/GiigA/ty6/55w/kf8aP7cuv+ecP5H/GiigA/ty6/wCecP5H/Gj+3Lr/AJ5w/kf8aKKAD+3Lr/nnD+R/xo/ty6/55w/kf8aKKAKd3dyXkokkCghdvyj/AD60UUUAf//Z';
